module.exports = __webpack_public_path__ + "img/red_cross.40019bcc.svg";